// @flow

import React from 'react';
import { connect } from 'react-redux';
import { getFormSettings } from '../../../../../store/formSettings/selectors';
import { ReduxFormLabeledSelect } from '../../../../form/labeledFields';
import ReduxFormField from '../../../../form/reduxFormField';
import type { Validators } from '../../../../form/reduxFormField';

type OwnProps = {|
  label: string,
  name: string,
  provinces: Array<string>,
  withValidator: Array<Validators> | Validators,
|};

type StateProps = {|
  firstOptionLabel: string,
|};

type Props = OwnProps & StateProps;

const ProvinceField = ({
  firstOptionLabel,
  label,
  name,
  withValidator,
  provinces,
}: Props) => (
  <ReduxFormField
    label={label}
    name={name}
    component={ReduxFormLabeledSelect}
    withValidator={withValidator}
  >
    <option value="" key="province">{firstOptionLabel}</option>
    {provinces.map(province => <option value={province} key={`province-${province}`}>{province}</option>)}
  </ReduxFormField>
);

const mapStateToProps = (state): StateProps => ({
  firstOptionLabel: getFormSettings(state).select_first_option_label,
});

export default connect<any, OwnProps, StateProps, any, any, any>(mapStateToProps)(ProvinceField);
